import { ProductReservation } from '_api/useReservations';
import { isBookingInSlot } from '_utils';
import { UnixTimeCode } from 'types/Utility';

const isSlotTaken = ({
    start,
    end,
    bookings,
    amount,
    capacity,
}: {
    start: UnixTimeCode;
    end: UnixTimeCode;
    bookings: ProductReservation[];
    amount: number;
    capacity: number;
}) => {
    // 1. Filter bookings that overlap with the slot
    const filteredBookings = bookings.filter(isBookingInSlot(start, end));
    const totalCount = filteredBookings.reduce((acc, curr) => curr.quantity + acc, 0);

    if (totalCount + amount <= capacity) {
        // Quick escape if we can't even reach capacity for all.
        return false;
    }

    // 2. Generate events for all bookings
    type Event = { time: number; quantity: number };
    const events: Array<Event> = [];
    filteredBookings.forEach((booking) => {
        events.push({ time: booking.start_at, quantity: booking.quantity });
        events.push({ time: booking.end_at, quantity: -booking.quantity });
    });

    // 3. Add the new/edited booking as two events
    events.push({ time: start, quantity: amount });
    events.push({ time: end, quantity: -amount });

    // 4. Sort events by time
    events.sort((a, b) => a.time - b.time);

    // 5. Iterate and check running sum
    let bookedCapacity = 0;
    for (const event of events) {
        bookedCapacity += event.quantity;
        if (bookedCapacity > capacity) {
            return true; // Slot is taken
        }
    }
    return false; // Slot is available
};

export default isSlotTaken;
